//basic grid layout
import {
	Avatar,
	Card,
	Chip,
	Divider,
	Grid,
	IconButton,
	Typography,
	makeStyles,
} from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import moment from "moment";
import colorChange from "../../utils/colorChanges";
import { ArrowBack } from "@material-ui/icons";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
	IconButton: {
		// border: "1px solid",
		color: "#3A6E86",
		fontWeight: "bold",
		display: "table-cell",
		right: 0,
		// alignItems: "center",
		[theme.breakpoints.down("sm")]: {
			// display: "none",
		},
	},
	textDiv: {
		display: "flex",
		justifyContent: "center",
	},
	textSubDiv: {
		width: "60%",
		textAlign: "center",
		textOverflow: "ellipsis",
		overflow: "hidden",
		whiteSpace: "nowrap",
		fontSize: "3rem",
		fontWeight: "bold",
		[theme.breakpoints.down("sm")]: {
			width: "80%",
			fontSize: "2rem",
		},
	},
	textSubDiv4: {
		width: "40%",
		textAlign: "center",
		textOverflow: "ellipsis",
		overflow: "hidden",
		whiteSpace: "nowrap",
		fontSize: "14px",
		color: "gray",
		[theme.breakpoints.down("sm")]: {
			width: "60%",
		},
	},
	chipDiv: {
		display: "flex",
		justifyContent: "center",
	},
	chipSubDiv: {
		display: "flex",
		gap: "0.3rem",
		justifyContent: "center",
		width: "80%",
		overflowX: "auto",
		padding: "1.5rem",
	},
	textDiv2: {
		textAlign: "left",
		marginLeft: "0.5rem",
	},
	textSubDiv2: {
		fontSize: "1rem",
		fontWeight: "bold",
		[theme.breakpoints.down("xs")]: {
			width: "90%",
			textOverflow: "ellipsis",
			overflow: "hidden",
			whiteSpace: "nowrap",
		},
	},
	textDiv3: {
		textAlign: "left",
		marginLeft: "0.5rem",
		display: "flex",
	},
	textSubDiv3: {
		fontSize: "0.9rem",
		width: "60%",
		wordWrap: "normal",
		textAlign: "justify",
		[theme.breakpoints.down("sm")]: {
			width: "100%",
		},
	},
	image: {
		display: "flex",
		justifyContent: "center",
		flexWrap: "wrap",
		gap: "16px",
		marginTop: "2rem",
	},
}));

export default function NestedGrid({ issues, modalImage, incident }) {
	const ChartWrapperStyle = styled("div")(({ theme }) => ({
		height: 372,
		marginBottom: theme.spacing(5),
	}));
	let history = useHistory();

	const handleLink = (path) => {
		history.push(`/task`);
	};

	const classes = useStyles();

	return (
		// <React.Fragment>
		<Card style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}>
			<ChartWrapperStyle style={{ height: "auto" }}>
				<IconButton onClick={handleLink} className={classes.IconButton}>
					<ArrowBack />
				</IconButton>
				<div className={classes.textDiv}>
					<div className={classes.textSubDiv}>{issues?.title}</div>
				</div>
				<Typography style={{ color: "GrayText" }}>
					<i>
						Ticket ID: <b>{issues?.idticket}</b>
					</i>
				</Typography>
				<div className={classes.textDiv}>
					<div className={classes.textSubDiv4}>
						<i>
							Location: <b>{issues?.location}</b>
						</i>
					</div>
				</div>
				<Typography style={{ color: "GrayText", fontSize: "14px" }}>
					<i>
						Date: <b>{moment(issues?.waktu).format("MMM, DD-YYYY HH:mm")}</b>
					</i>
				</Typography>
				<div className={classes.chipDiv}>
					<div className={classes.chipSubDiv}>
						<Chip
							size="medium"
							label={`#${issues?.priority}`}
							variant="default"
							style={{
								backgroundColor: colorChange(issues.priority)?.backgroundColor,
								color: colorChange(issues.priority)?.color,
								fontWeight: "bold",
							}}
						/>
						<Chip
							size="medium"
							label={`${issues?.status}`}
							variant="default"
							style={{
								backgroundColor: colorChange(issues.status)?.backgroundColor,
								color: colorChange(issues.status)?.color,
								fontWeight: "bold",
							}}
						/>
						{/* <Chip
								size="medium"
								label={`Location: ${issues?.location}`}
								variant="default"
								style={{
									backgroundColor: "GrayText",
									color: "white",
									fontWeight: "bold",
									textOverflow: "ellipsis",
									overflow: "hidden",
									whiteSpace: "nowrap",
								}}
							/> */}
					</div>
				</div>
				<div
					style={{ padding: "0px 1rem", minWidth: "1rem", marginTop: "1rem" }}
				>
					<Grid container wrap="nowrap">
						<Grid item>
							<Avatar alt={issues?.name}>{issues?.initial}</Avatar>
						</Grid>
						<Grid item>
							<div className={classes.textDiv2}>
								<div className={classes.textSubDiv2}>{issues?.name}</div>
							</div>
							<div className={classes.textDiv3}>
								<div className={classes.textSubDiv3}>{issues?.deskripsi}</div>
							</div>
						</Grid>
					</Grid>
					<Divider variant="fullWidth" />
					<div className={classes.image}>
						{issues?.picture
							? issues?.picture?.map((row) => {
								return (
									<img
										onClick={() => modalImage(issues)}
										alt={`${row.url_gambar}`}
										src={`${row.url_gambar}`}
										style={{ maxWidth: "100%", objectFit: "scale-down" }}
										width="300px"
									/>
								);
							})
							: ""}
					</div>
					{issues?.idkategori === 99999 && (
						<div style={{ marginTop: "1rem" }}>
							<Typography variant="h6" color="textSecondary">
								Incident Details
							</Typography>
							<Grid container spacing={2} style={{ marginTop: 8 }}>
								{[
									{ label: 'Vehicle Type', value: incident.data.vehicle_type || '-' },
									{ label: 'Jenis Kecelakaan', value: incident.data.jenis_kecelakaan || '-' },
									{ label: 'Detail Jenis Kecelakaan', value: incident.data.detail_jenis_kecelakaan || '-' },
									{ label: 'Golongan', value: incident.data.golongan || '-' },
									{ label: 'Gender', value: incident.data.gender === 0 ? 'Perempuan' : incident.data.gender === 1 ? 'Laki-laki' : incident.data.gender === 2 ? 'Tidak diketahui' : '-' },
									{ label: 'Faktor Penyebab', value: incident.data.faktor_penyebab || '-' },
									{ label: 'Sub Faktor', value: incident.data.sub_factor || '-' },
									{ label: 'Luka Ringan', value: incident.data.luka_ringan ?? '-' },
									{ label: 'Luka Berat', value: incident.data.luka_berat ?? '-' },
									{ label: 'Korban Meninggal', value: incident.data.korban_meninggal ?? '-' },
									{ label: 'Kendaraan Terlibat', value: incident.data.kendaraan_terlibat ?? '-' },
								].map((item, idx) => (
									<Grid item xs={12} sm={6} md={4} lg={2} xl={2} key={idx} style={{ minWidth: 120 }}>
										<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginBottom: 8 }}>
											<Typography variant="caption" color="textSecondary" style={{ fontWeight: 600 }}>{item.label}</Typography>
											<Typography variant="body2">{typeof item.value === 'string' ? item.value.toUpperCase() : item.value}</Typography>
										</div>
									</Grid>
								))}
							</Grid>
						</div>
					)}
				</div>
			</ChartWrapperStyle>
		</Card>
		// </React.Fragment>
	);
}
